import Vue from 'vue'
import axios from '../plugins/axios'

Vue.prototype.$http = axios

const pro = {
    namespaced: true,
    state: {
        contact: null,
        notFoundContact: false
    },
    mutations: {
        setContact(state, value) {
            state.contact = value
        },
        setNotFoundContact(state, value) {
            state.notFoundContact = value
        }
    },
    actions: {
        fetchContact({ commit }, id) {
            Vue.prototype.$http.get('professional/contact/' + id).then(res => {
                commit('setContact', res.body.data.contact)

                commit('setNotFoundContact', res.body.data.contact === null)
            })
        },
    }
}

export default pro